import { type SimpleEventLegacy } from '@verantos-dev/types-cohorts';
import { Simple_eventContext } from '@verantos-dev/util-cohort-builder-typescript-runtime';

import getConditionOccurrenceEvent from '../helpers/getConditionOccurrenceEvents';
import getDrugExposureEvents from '../helpers/getDrugExposureEvents';
import getMeasurementEvents from '../helpers/getMeasurementEvents';
import getObservationEvents from '../helpers/getObservationEvents';
import getProcedureOccurrenceEvents from '../helpers/getProcedureOccurrenceEvents';
import getVisitOccurrenceEvents from '../helpers/getVisitOccurrenceEvents';

export const generateSimpleEventFromDSL = (
  simpleEvent: any,
  dirty?: boolean // set to true to annotate input fields as dirty
): SimpleEventLegacy[] => {
  try {
    return simpleEvent?.reduce((acc: any[], event: Simple_eventContext) => {
      if (event.condition_occurrence_event()) {
        acc.push(getConditionOccurrenceEvent(event, dirty));
      } else if (event.drug_exposure_event()) {
        acc.push(getDrugExposureEvents(event, dirty));
      } else if (event.measurement_event()) {
        acc.push(getMeasurementEvents(event, dirty));
      } else if (event.observation_event()) {
        acc.push(getObservationEvents(event, dirty));
      } else if (event.procedure_occurrence_event()) {
        acc.push(getProcedureOccurrenceEvents(event, dirty));
      } else if (event.visit_occurrence_event()) {
        acc.push(getVisitOccurrenceEvents(event, dirty));
      }
      return acc;
    }, []);
  } catch (error) {
    console.error('Error fetching simple events', error);
    return [];
  }
};
